import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Box,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";

import useMenuStore from "../../stores/MenuStore";
import Icon from "../../components/Icon";
import MessageDialog from "../../components/Login/MessageDialog";
import useAuth from "../../context/AuthContext";

const TopBar: React.FC = () => {
  const { isAdminMode, toggleAdminMode, toggleDrawer } = useMenuStore();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const [dialogData, setDialogData] = useState({});
  const { logout } = useAuth();

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChangePassword = () => {
    setDialogData({ component: "ChangePassword", size: "md", active: true });
  };
  const handleComponent = (value: boolean) => {
    setDialogData({ active: false });
  };

  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          bgcolor: isAdminMode ? "#555555" : "#888888",
        }}
      >
        <Toolbar sx={{ height: 10 }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleDrawer}
            className="button normal"
          >
            <img src="/images/logo_ma.png" alt="Logo Medidas Ambientales" />
          </IconButton>
          <Box sx={{ flexGrow: 1 }} /> {/* Este Box actúa como un separador */}
          {/* Aquí se añade el nuevo Box para la imagen centrada */}
          {/*<Box sx={{ display: 'flex', justifyContent: 'left', flexGrow: 1, height:'4vh' }}>
                        <img src='/images/Eurofresh.png' alt='Descripción de la imagen' style={{ maxWidth: '100%'}} />
                    </Box>*/}
          {/* Botón de configuración de administración*/}
          {/*<Box sx={{ display: 'flex', alignItems: 'center', ml: 2, mr: 3 }}>
                        <Button size='small' startIcon={<SettingsIcon />} color='inherit' aria-label='admin settings'
                            onClick={() => { toggleAdminMode(); isAdminMode ? navigate(pathRoutes.PORTAL_HOMOLOGATIONS_REVISION) : navigate(pathRoutes.ADMIN_USUARIOS); }}                        >
                            {isAdminMode ? 'Modo Admin' : 'Modo Usuario'}
                        </Button>
                    </Box>*/}
          <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
            edge="start"
            sx={{ color: "#4A4A4A", fontSize: "20px" }}
            className={`button user ${isMenuOpen ? "active" : ""}`}
          >
            <Icon name="user" width="24px" height="24px" />
            <Box sx={{ p: "0 10px" }}>{isAdminMode ? "Admin" : "Usuario"}</Box>
            <ExpandMore />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={handleChangePassword}>Cambiar contraseña</MenuItem>
        <MenuItem onClick={logout}>Cerrar sesión</MenuItem>
        {/* <MenuItem onClick={handleMenuClose}>Perfil</MenuItem>
                <MenuItem onClick={handleMenuClose}>Mi cuenta</MenuItem> */}
      </Menu>
      <MessageDialog
        data={dialogData}
        handleClose={handleComponent}
      ></MessageDialog>
    </>
  );
};

export default TopBar;
